import { useCallback } from 'react'
import { Definition, DefinitionLabel, DefinitionValue } from '@cargomart/ui'
import { UserDocumentTypeItem, UserInfoDocument } from 'schema'
import { PlaceholderCell } from 'src/tailwind-components/extends/PlaceholderCell'

interface ProfileDocumentProps {
  document: UserInfoDocument[]
  isLoading: boolean
  documentType?: UserDocumentTypeItem[]
}

const LoadingDocument = () => (
  <Definition labelClassName="!text-body-md !py-1" valueClassName="!py-1">
    <DefinitionLabel>Паспорт РФ</DefinitionLabel>
    <DefinitionValue>
      <PlaceholderCell height={20} seed={2} />
    </DefinitionValue>
    <DefinitionLabel>Водительское удостоверение</DefinitionLabel>
    <DefinitionValue>
      <PlaceholderCell height={20} seed={1} />
    </DefinitionValue>
    <DefinitionLabel>Заграничный паспорт</DefinitionLabel>
    <DefinitionValue>
      <PlaceholderCell height={20} seed={1} />
    </DefinitionValue>
  </Definition>
)

export const ProfileDocument = ({ document, documentType, isLoading = true }: ProfileDocumentProps) => {
  const getTitle = useCallback(
    (type: string) => documentType?.find(({ code }) => type === code)?.title || '—',
    [documentType]
  )

  return (
    <div
      className="mt-6 grid grid-cols-1 gap-x-4 pb-5 md:grid-cols-[160px,auto]"
      data-test-id="profile-settings--document"
    >
      {isLoading ? (
        <LoadingDocument />
      ) : (
        <Definition labelClassName="!text-body-md !py-1" valueClassName="!py-1">
          {document.map(({ type, number, series }) => (
            <>
              <DefinitionLabel>{getTitle(type)}</DefinitionLabel>
              <DefinitionValue>{`${series} ${number}`}</DefinitionValue>
            </>
          ))}
        </Definition>
      )}
    </div>
  )
}
